/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ClinicalDictionary from './clinical-dictionary';
import ClinicalDictionaryDetail from './clinical-dictionary-detail';
import ClinicalDictionaryUpdate from './clinical-dictionary-update';
import ClinicalDictionaryDeleteDialog from './clinical-dictionary-delete-dialog';

const ClinicalDictionaryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ClinicalDictionary />} />
    <Route path="new" element={<ClinicalDictionaryUpdate />} />
    <Route path=":id">
      <Route index element={<ClinicalDictionaryDetail />} />
      <Route path="edit" element={<ClinicalDictionaryUpdate />} />
      <Route path="delete" element={<ClinicalDictionaryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ClinicalDictionaryRoutes;
